import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../api-services/Auth/auth.service';
/**
 * This component is user can forgot his/her password.
 * He/she update is email id here and to sent mail for reset the password. 
 */
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm =new FormGroup({
    userName: new FormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')])
  });
  forgotData: any;
  showMsg: boolean = true;
  showForgot: boolean = true;
  errorMsg: boolean =false;
  constructor(private passwordService:AuthService) { }

  ngOnInit() {
    
  }
  postForgotEmail() {
    if(!this.forgotPasswordForm.valid){ 
     return this.forgotPasswordForm.markAllAsTouched();
    }else{
      this.passwordService.forgotPasswordService(this.forgotPasswordForm.value).subscribe(data => {
      this.forgotData = data
      if ( this.forgotData.status) {
        this.errorMsg =false;
        this.showMsg = false;
      }
      else {
        this.errorMsg =true;
        this.showMsg = true;
      }
    });
    }
   
  }
}
